var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5L21.5 11.5M11.5 6.5L11.5 21.5M10.5 6.5H17.5C18.9001 6.5 19.6002 6.5 20.135 6.77248C20.6054 7.01217 20.9878 7.39462 21.2275 7.86502C21.5 8.3998 21.5 9.09987 21.5 10.5V17.5C21.5 18.9001 21.5 19.6002 21.2275 20.135C20.9878 20.6054 20.6054 20.9878 20.135 21.2275C19.6002 21.5 18.9001 21.5 17.5 21.5H10.5C9.09987 21.5 8.3998 21.5 7.86502 21.2275C7.39462 20.9878 7.01217 20.6054 6.77248 20.135C6.5 19.6002 6.5 18.9001 6.5 17.5V10.5C6.5 9.09987 6.5 8.3998 6.77248 7.86502C7.01217 7.39462 7.39462 7.01217 7.86502 6.77248C8.3998 6.5 9.09987 6.5 10.5 6.5Z",
    stroke: "#101828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid_icon.444304fda765e6a6d7a873108e52ec6c.svg";
export { ForwardRef as ReactComponent };